import "./main.css";

import { AppRoutes } from "@/components/AppRoutes";
import { AnalyticsProvider } from "@Light/app/analytics";
import { LightContext } from "@Light/services/light";
import { init } from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./app/store";
import { light } from "./services/light";

const environment = import.meta.env.MODE;
const isRelease = ["production", "staging"].includes(environment);
init({
  enabled: isRelease,
  dsn: "https://23e81cb9b89cc131cf5029cb2b2bf9f7@o4506870612688896.ingest.us.sentry.io/4510727906787328",
  environment,
});

// TODO: upgrade to react 19
// createRoot(document.getElementById("root")!, {
//   onCaughtError: reactErrorHandler(),
//   onRecoverableError: reactErrorHandler(),
//   onUncaughtError: reactErrorHandler((error, errorInfo) => {
//     console.error(error, errorInfo.componentStack);
//   }),
// }).render(...)

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <LightContext.Provider value={light}>
          <AnalyticsProvider useLocalStorage>
            <AppRoutes />
          </AnalyticsProvider>
        </LightContext.Provider>
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
